// Logo animation on page load
document.addEventListener('DOMContentLoaded', function() {
  const logoLetters = document.querySelectorAll('.barrio-logo path');
  
  if (logoLetters.length > 0) {
    logoLetters.forEach((letter, index) => {
      // Set initial state
      letter.style.transform = 'translate3d(0, 33vh, 0)';
      letter.style.opacity = '0';
      
      // Animate with staggered delay (100ms between each letter)
      setTimeout(() => {
        letter.style.transform = 'translate3d(0, 0, 0)';
        letter.style.opacity = '1';
      }, index * 100);
    });
  }
});